export default __webpack_public_path__ + "static/media/icon_lock_gray.e1cf91d8.svg";